export default "__VITE_ASSET__DBjfSanb__"